import {showNotification} from 'platform/components';

import {UseFormReturn} from 'react-hook-form';

import {isNil} from 'ramda';

import {useLazyCalculateFromWithoutVatQuery} from '@dms/api/core';
import {CountryAlpha3CodeEnum, VatRateType} from '@dms/api/shared';
import i18n from '@dms/i18n';

import {precisionCalculation, useOnMount} from 'shared/web';

import {DeliveryNoteDocumentPreviewFormDefinition} from '../types/DeliveryNoteDocumentPreviewFormDefinition';

interface UseRecalculateAllPricesOnMountProps {
  formApi: UseFormReturn<DeliveryNoteDocumentPreviewFormDefinition>;
  countryCode: CountryAlpha3CodeEnum;
  onComplete: (values: DeliveryNoteDocumentPreviewFormDefinition) => void;
}

export function useRecalculateAllPricesOnMount(props: UseRecalculateAllPricesOnMountProps) {
  const [calculatePriceWithoutVat] = useLazyCalculateFromWithoutVatQuery();

  useOnMount(() => {
    const listOfItems = props.formApi.getValues('listOfItems');

    if (!listOfItems || listOfItems.length === 0) {
      return;
    }

    let hasAnyError = false;

    const recalculatePromises = listOfItems.map((item, index) => {
      if (isNil(item.vat) || isNil(item.totalPrice) || item.totalPrice <= 0) {
        return Promise.resolve();
      }

      return calculatePriceWithoutVat({
        amount: item.totalPrice.toString(),
        vatRateType: item.vat as VatRateType,
        countryCode: props.countryCode,
      })
        .unwrap()
        .then((result) => {
          props.formApi.setValue(
            `listOfItems.${index}.totalPriceWithVat`,
            precisionCalculation.round(Number(result.withVat.replace(',', '.')), 2)
          );
        })
        .catch(() => {
          hasAnyError = true;
        });
    });

    Promise.all(recalculatePromises).then(() => {
      if (hasAnyError) {
        showNotification.error(
          i18n.t('entity.documentExtraction.notifications.pricesNotCalculatedProperly')
        );
      }
      const currentValues = props.formApi.getValues();
      props.onComplete(currentValues);
    });
  });
}
